module.exports = __webpack_public_path__ + "img/applied-journalism.0c1e6df5.jpg";